import { AllowedHttpMethods } from '~/features/agent-forge/types';
import { pilotV3 } from '~/services/serviceInstances';

interface Request {
  agent_forge_url: string;
  tenant: string;
  tenant_env: string;
  agent_forge_payload?: Record<string, unknown>;
  agent_forge_headers?: Record<string, unknown>;
  agent_forge_http_method?: AllowedHttpMethods;
}

export const getAgentForgeInvocations = async (
  request: Request,
): Promise<unknown> => {
  return await pilotV3.post('/agentforge/invoke/', request);
};
